import { render, staticRenderFns } from "./ZX.vue?vue&type=template&id=24071e21&scoped=true&"
var script = {}
import style0 from "./ZX.vue?vue&type=style&index=0&id=24071e21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24071e21",
  null
  
)

export default component.exports